import { useEffect, useRef, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { Result, Spin } from 'antd'
import { useAuthStore } from '@/stores/authStore'

export function SsoHyperpay() {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const entrarComLoginToken = useAuthStore((s) => s.entrarComLoginToken)
  const [falhou, setFalhou] = useState(false)
  // O React roda o efeito duas vezes em StrictMode e o login token é de uso único: a segunda
  // troca falharia e derrubaria a sessão que a primeira acabou de abrir.
  const jaTrocou = useRef(false)

  useEffect(() => {
    if (jaTrocou.current) return
    jaTrocou.current = true

    const loginToken = searchParams.get('loginToken')
    if (!loginToken) {
      setFalhou(true)
      return
    }

    entrarComLoginToken(loginToken)
      .then(() => navigate('/embutido/matricula', { replace: true }))
      .catch(() => setFalhou(true))
  }, [searchParams, entrarComLoginToken, navigate])

  if (falhou) {
    return (
      <Result
        status="warning"
        title="Não foi possível entrar"
        subTitle="O acesso expirou. Volte ao Hyperpay e abra o New Driver novamente."
      />
    )
  }

  return (
    <div className="flex items-center justify-center min-h-screen">
      <Spin size="large" />
    </div>
  )
}
